// ─────────────────────────────────────────────────────────────────────────────
// SEO & AI SEARCH — NGUỒN CHÂN LÝ DUY NHẤT
//
// File này là thứ tab "Cài đặt → SEO & AI Search" trong Upbo đọc và ghi. Cả hai
// nửa của dự án đều dùng chung nó: client render thẻ meta từ đây, Worker sinh
// robots.txt / sitemap.xml / llms.txt cũng từ đây. Sửa một chỗ, đúng mọi nơi.
// ─────────────────────────────────────────────────────────────────────────────

export interface SeoConfig {
  /** Tên thương hiệu. Vào <title>, og:site_name và JSON-LD. */
  siteName: string
  /** Mô tả 1–2 câu. Đây là câu mà AI trích ra khi giới thiệu website. */
  description: string
  /** URL gốc, KHÔNG có dấu / cuối. Để trống thì suy ra từ request. */
  siteUrl: string
  locale: string
  /** Ảnh chia sẻ mạng xã hội (1200×630). Đường dẫn tuyệt đối hoặc /og.png. */
  ogImage: string
  /** Loại thực thể cho JSON-LD schema.org. */
  organizationType: 'Organization' | 'LocalBusiness' | 'Person' | 'WebSite'
  /** Từ khoá chính — dùng cho llms.txt, KHÔNG dùng cho <meta keywords> (đã chết). */
  keywords: string[]
  /** Liên kết mạng xã hội → JSON-LD sameAs, giúp AI nối website với thương hiệu. */
  sameAs: string[]

  /**
   * Cho phép crawler của các nhà cung cấp AI đọc website.
   *
   * BẬT (mặc định) = website có cơ hội được ChatGPT, Claude, Perplexity, Gemini…
   * trích dẫn khi người dùng hỏi. Đây chính là kênh marketing mới.
   * TẮT = robots.txt chặn hẳn các bot đó.
   */
  allowAiCrawlers: boolean

  /**
   * Trả HTML đã render sẵn cho crawler.
   *
   * VÌ SAO TỐI QUAN TRỌNG: đây là ứng dụng SPA — trình duyệt thật chạy
   * JavaScript rồi mới thấy nội dung, nhưng hầu hết crawler của AI thì KHÔNG
   * chạy JavaScript. Không có cờ này, thứ GPTBot/ClaudeBot nhìn thấy chỉ là
   * <div data-upbo-src="shared/seo.config.tsx:41" id="root"></div> rỗng, và website coi như vô hình với AI search.
   * Worker sẽ nhận diện bot rồi chèn thẳng nội dung thật vào HTML.
   */
  prerenderForBots: boolean

  /** Trang tĩnh cần có trong sitemap (ngoài nội dung động lấy từ database). */
  staticRoutes: string[]
}

export const seo: SeoConfig = {
  siteName: 'Upbo App',
  description:
    'Ứng dụng web được xây dựng trên Upbo — client và server trong một mã nguồn, dữ liệu nằm trên database của chính bạn.',
  siteUrl: '',
  locale: 'vi_VN',
  ogImage: '/og.png',
  organizationType: 'Organization',
  keywords: [],
  sameAs: [],
  allowAiCrawlers: true,
  prerenderForBots: true,
  staticRoutes: ['/'],
}

/** Ghép title cho từng trang: "Trang chủ — Upbo App". */
export function pageTitle(title?: string): string {
  return title && title !== seo.siteName ? `${title} — ${seo.siteName}` : seo.siteName
}

/** URL tuyệt đối, ưu tiên siteUrl đã cấu hình rồi mới tới origin của request. */
export function absoluteUrl(path: string, origin?: string): string {
  const base = (seo.siteUrl || origin || '').replace(/\/$/, '')
  return `${base}${path.startsWith('/') ? path : `/${path}`}`
}
